import AssignmentDrawer from "../../Employee/Assignment/AssignmentDrawer";
import { useState } from "react";

const CrfAssignmentCreation = (props) => {
  const { isOpen, handleClose, createAssignmentData } = props;
  const [stepperData, setStepperData] = useState(undefined);
  const [headerType, setHeaderType] = useState(undefined);
  const [headerModal, setHeaderModal] = useState("");
  const [fetchApiFlag, setFetchApiFlag] = useState(false);
  const [headerInputValue, setHeaderInputValue] = useState("");

  return (
    <>
      {isOpen ? (
        <AssignmentDrawer
          handleClose={handleClose}
          currentSelection={{
            ...createAssignmentData,
            id: createAssignmentData?.assignment_id,
          }}
          setStepperData={setStepperData}
          stepperData={stepperData}
          setHeaderModal={setHeaderModal}
          headerModal={headerModal}
          headerType={headerType}
          setHeaderType={setHeaderType}
          setHeaderInputValue={setHeaderInputValue}
          headerInputValue={headerInputValue}
          fetchApiFlag={fetchApiFlag}
          setFetchApiFlag={setFetchApiFlag}
        />
      ) : null}
    </>
  );
};
export default CrfAssignmentCreation;
